import { render, staticRenderFns } from "./CommentCount.vue?vue&type=template&id=bad22c8c&scoped=true&"
import script from "./CommentCount.vue?vue&type=script&lang=js&"
export * from "./CommentCount.vue?vue&type=script&lang=js&"
import style0 from "./CommentCount.vue?vue&type=style&index=0&id=bad22c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad22c8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
